<div class="task" >
  @if (modeEdition) {
    <form (ngSubmit)="saveLibelleItem()" class="liste_content-info is-edit">
      <input [formControl]="libelle" name="libelle" type="text" #inputFocus />
      <button class="button-green-icon is-small" type="submit" [disabled]="isLibelleInvalide()">
        <i class="icon icon-validate"></i>
      </button>
    </form>
  } @else {
    <app-form-field [control]="estCoche" >
      <div class="checkboxes-big">
        <input type="checkbox" [checked]="item.estCoche == true" (change)="saveEstCocheItem()" [disabled]="!_editable" [id]="getHTMLElementId()">
        <label [for]="getHTMLElementId()" class="task-name" [ngClass]="{'is-checked': item.estCoche == true}"><p >{{item.libelle}}</p></label>
      </div>
    </app-form-field >
    @if (_editable) {
      <div class="task-more">
        <div class='button-task-more e-caret-hide' ejs-dropdownbutton
          [items]='menu' (select)='menuActions($event)'>
          <i class='icon icon-more-vertical'></i>
        </div>
      </div>
    }
  }
</div>
